export const translations = {
  en: {
    common: {
      cancel: "Cancel",
      none: "None",
      unassigned: "Unassigned",
      empty: "Empty",
      viewAll: "View all",
      noData: "No data",
      saveChanges: "Save changes",
      loading: "Loading…",
    },
    nav: {
      dashboard: "Dashboard",
      cases: "Cases & Complaints",
      newCase: "New Submission",
      kpi: "KPI & Reports",
      logs: "Activity Logs",
      users: "User Management",
      portal: "Legal Case & Complaints Management",
      footer1: "Delta Medical Laboratories",
      footer2: "Legal Case & Complaints Portal",
    },
    header: {
      signOut: "Sign out",
      notifications: "Notifications",
      markAllRead: "Mark all read",
      noNotifications: "No notifications yet.",
      notifFail: "Could not mark notifications as read",
    },
    login: {
      welcome: "Welcome back",
      subtitle: "Sign in with your Delta account to continue.",
      msButton: "Sign in with Microsoft",
      msPending: "Microsoft SSO activates once IT provides the Azure AD (Entra ID) app credentials.",
      msTooltipOn: "Sign in with your Microsoft work account",
      msTooltipOff: "Microsoft SSO pending Azure AD configuration by IT",
      orEmail: "or with email",
      email: "Email",
      password: "Password",
      signIn: "Sign in",
      fail: "Sign in failed",
      msFail: "Microsoft sign in failed",
      hero1: "Legal Case &",
      hero2: "Complaints Portal",
      heroText: "Submit, track and resolve legal complaints across B2B partners and outpatient clinics — with full audit trails, KPIs and instant notifications.",
      feat1: "Complaint & case submissions with PDF attachments",
      feat2: "Role-based access: Requester, Lawyer, Admin, Super Admin",
      feat3: "KPIs, activity logs and one-click Excel exports",
      brandFooter: "Delta دلتا Medical Laboratories — Internal Legal Operations",
    },
    dashboard: {
      welcome: "Welcome back, {name}",
      overview: "{role} overview · Delta Medical Laboratories",
      submit: "Submit New Complaint",
      urgentOne: "{count} urgent case needs immediate attention.",
      urgentMany: "{count} urgent cases need immediate attention.",
      review: "Review",
      total: "Total Cases",
      open: "Open Cases",
      resolved: "Resolved",
      avg: "Avg Resolution",
      byStatus: "Cases by Status",
      b2bOut: "B2B vs Outpatient",
      noCases: "No cases yet",
      recent: "Recent Cases",
      emptyText: "No cases yet. Submit your first complaint to get started.",
      emptyCta: "New Submission",
    },
    cases: {
      title: "Cases & Complaints",
      subRequester: "Your submitted complaints and cases.",
      subStaff: "All submissions across B2B and Outpatient.",
      export: "Export Excel",
      exporting: "Exporting…",
      new: "New Submission",
      search: "Search by number, title or description…",
      allStatuses: "All statuses",
      allCompanies: "All companies",
      allPriorities: "All priorities",
      empty: "No cases match your filters.",
      emptyCta: "Submit a complaint",
      loadFail: "Could not load cases",
      exported: "Excel report downloaded",
      exportFail: "Export failed",
      colNumber: "Case #",
      colTitle: "Title",
      colType: "Type",
      colCompany: "Company",
      colPriority: "Priority",
      colStatus: "Status",
      colAssigned: "Assigned",
      colUpdated: "Updated",
    },
    newCase: {
      title: "New Submission",
      subtitle: "Submit a complaint or legal case. The legal team will be notified instantly.",
      card: "Case details",
      titleLabel: "Title",
      titlePh: "Short summary, e.g. Billing dispute with corporate client",
      type: "Type",
      company: "Company Category",
      priority: "Priority",
      desc: "Description",
      descPh: "Describe the issue in detail: parties involved, dates, amounts, and any relevant context…",
      attach: "Attachments (optional)",
      dropTitle: "Click to attach PDFs or documents",
      dropHint: "PDF, Word, Excel, images · max 15 MB each · up to 10 files",
      submit: "Submit",
      submitting: "Submitting…",
      success: "{number} submitted successfully",
      fail: "Could not submit the case",
    },
    detail: {
      notFound: "Case not found or you don't have access.",
      back: "Back to cases",
      changeStatus: "Change Status",
      edit: "Edit",
      details: "Details",
      attachments: "Attachments ({count})",
      upload: "Upload",
      noAttachments: "No attachments yet.",
      assignedLawyer: "Assigned Lawyer",
      assignToMe: "Assign to me",
      timeline: "Timeline & Discussion",
      noActivity: "No activity yet.",
      addComment: "Add a comment…",
      statusDialog: "Change case status",
      newStatus: "New status",
      note: "Note (required — shared with stakeholders)",
      notePh: "Reason for this status change…",
      updateStatus: "Update status",
      editCase: "Edit case",
      metaType: "Type",
      metaCompany: "Company",
      metaPriority: "Priority",
      metaBy: "Submitted by",
      metaCreated: "Created",
      metaUpdated: "Last updated",
      statusUpdated: "Status updated — stakeholders notified",
      statusFail: "Could not update status",
      assignOk: "Assignment updated",
      assignFail: "Could not assign lawyer",
      updated: "Case updated",
      updateFail: "Could not update case",
      commentFail: "Could not post comment",
      uploadedToast: "{name} uploaded",
      uploadFail: "Upload failed",
      downloadFail: "Download failed",
      needStatus: "Select a status and add a short note",
    },
    kpi: {
      title: "KPI & Reports",
      subtitle: "Legal operations performance across the last 6 months.",
      casesExcel: "Cases Excel",
      kpiExcel: "KPI Report Excel",
      total: "Total Cases",
      open: "Open",
      resolved: "Resolved",
      escalated: "Escalated (Open)",
      avg: "Avg Resolution",
      days: "{n} days",
      monthly: "Monthly Case Volume",
      byStatus: "By Status",
      byCompany: "By Company Category",
      byPriority: "By Priority",
      workload: "Lawyer Workload",
      lawyer: "Lawyer",
      assigned: "Assigned",
      openCol: "Open",
      noAssignments: "No assignments yet.",
      cases: "Cases",
      loadFail: "Could not load KPIs",
    },
    logs: {
      title: "Activity Logs",
      subtitle: "Full audit trail of every action in the portal.",
      search: "Search by user, case or detail…",
      allActions: "All actions",
      empty: "No log entries found.",
      loadFail: "Could not load logs",
    },
    users: {
      title: "User Management",
      subSuper: "Create and manage all accounts, including admins.",
      subAdmin: "Create and manage lawyer and requester accounts.",
      add: "Add User",
      colName: "Name",
      colEmail: "Email",
      colRole: "Role",
      colCompany: "Company",
      colStatus: "Status",
      colJoined: "Joined",
      colActions: "Actions",
      active: "Active",
      suspended: "Suspended",
      suspend: "Suspend",
      reactivate: "Reactivate",
      you: "(you)",
      matrixTitle: "Role Permission Matrix",
      addTitle: "Add new user",
      fullName: "Full name",
      namePh: "e.g. Layla Haddad",
      emailPh: "name@deltalab.com",
      tempPw: "Temporary password (min 8 characters)",
      pwPh: "Set an initial password",
      role: "Role",
      companyOptional: "Company tag (optional)",
      create: "Create account",
      created: "Account created for {name}",
      roleChanged: "{name} is now {role}",
      toggled: "{name} {state}",
      stateSuspended: "suspended",
      stateReactivated: "reactivated",
      updateFail: "Update failed",
      createFail: "Could not create user",
      loadFail: "Could not load users",
      capability: "Capability",
      cap1: "Submit complaints & cases",
      cap2: "Upload attachments",
      cap3: "View all cases",
      cap4: "Change case status",
      cap5: "Assign lawyers",
      cap6: "View KPI & reports",
      cap7: "Excel export",
      cap8: "View activity logs",
      cap9: "Manage requesters & lawyers",
      cap10: "Manage admins",
    },
  },
  ar: {
    common: {
      cancel: "إلغاء",
      none: "بدون",
      unassigned: "غير معيَّن",
      empty: "فارغ",
      viewAll: "عرض الكل",
      noData: "لا توجد بيانات",
      saveChanges: "حفظ التغييرات",
      loading: "جارٍ التحميل…",
    },
    nav: {
      dashboard: "لوحة التحكم",
      cases: "القضايا والشكاوى",
      newCase: "طلب جديد",
      kpi: "مؤشرات الأداء والتقارير",
      logs: "سجلات النشاط",
      users: "إدارة المستخدمين",
      portal: "إدارة القضايا والشكاوى القانونية",
      footer1: "مختبرات دلتا الطبية",
      footer2: "بوابة القضايا والشكاوى القانونية",
    },
    header: {
      signOut: "تسجيل الخروج",
      notifications: "الإشعارات",
      markAllRead: "تعليم الكل كمقروء",
      noNotifications: "لا توجد إشعارات بعد.",
      notifFail: "تعذر تعليم الإشعارات كمقروءة",
    },
    login: {
      welcome: "مرحباً بعودتك",
      subtitle: "سجّل الدخول بحساب دلتا للمتابعة.",
      msButton: "تسجيل الدخول بحساب Microsoft",
      msPending: "سيتم تفعيل الدخول عبر Microsoft بعد أن توفر إدارة تقنية المعلومات بيانات تطبيق Azure AD (Entra ID).",
      msTooltipOn: "سجّل الدخول بحساب العمل Microsoft",
      msTooltipOff: "الدخول عبر Microsoft بانتظار إعداد Azure AD من قِبل تقنية المعلومات",
      orEmail: "أو عبر البريد الإلكتروني",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      signIn: "تسجيل الدخول",
      fail: "فشل تسجيل الدخول",
      msFail: "فشل تسجيل الدخول عبر Microsoft",
      hero1: "بوابة القضايا",
      hero2: "والشكاوى القانونية",
      heroText: "قدّم وتتبّع وعالج الشكاوى القانونية لشركاء الأعمال والعيادات الخارجية — مع سجلات تدقيق كاملة ومؤشرات أداء وإشعارات فورية.",
      feat1: "تقديم الشكاوى والقضايا مع مرفقات PDF",
      feat2: "صلاحيات حسب الدور: مقدم طلب، محامٍ، مشرف، مشرف عام",
      feat3: "مؤشرات أداء وسجلات نشاط وتصدير Excel بنقرة واحدة",
      brandFooter: "مختبرات دلتا الطبية — العمليات القانونية الداخلية",
    },
    dashboard: {
      welcome: "مرحباً بعودتك، {name}",
      overview: "نظرة عامة · {role} · مختبرات دلتا الطبية",
      submit: "تقديم شكوى جديدة",
      urgentOne: "حالة عاجلة واحدة تحتاج إلى اهتمام فوري.",
      urgentMany: "{count} حالات عاجلة تحتاج إلى اهتمام فوري.",
      review: "مراجعة",
      total: "إجمالي القضايا",
      open: "القضايا المفتوحة",
      resolved: "تم حلها",
      avg: "متوسط مدة الحل",
      byStatus: "القضايا حسب الحالة",
      b2bOut: "شركات الأعمال مقابل العيادات الخارجية",
      noCases: "لا توجد قضايا بعد",
      recent: "أحدث القضايا",
      emptyText: "لا توجد قضايا بعد. قدّم شكواك الأولى للبدء.",
      emptyCta: "طلب جديد",
    },
    cases: {
      title: "القضايا والشكاوى",
      subRequester: "الشكاوى والقضايا التي قدمتها.",
      subStaff: "جميع الطلبات عبر شركات الأعمال والعيادات الخارجية.",
      export: "تصدير Excel",
      exporting: "جارٍ التصدير…",
      new: "طلب جديد",
      search: "ابحث بالرقم أو العنوان أو الوصف…",
      allStatuses: "كل الحالات",
      allCompanies: "كل الشركات",
      allPriorities: "كل الأولويات",
      empty: "لا توجد قضايا مطابقة للفلاتر.",
      emptyCta: "قدّم شكوى",
      loadFail: "تعذر تحميل القضايا",
      exported: "تم تنزيل تقرير Excel",
      exportFail: "فشل التصدير",
      colNumber: "رقم القضية",
      colTitle: "العنوان",
      colType: "النوع",
      colCompany: "الشركة",
      colPriority: "الأولوية",
      colStatus: "الحالة",
      colAssigned: "المعيَّن",
      colUpdated: "آخر تحديث",
    },
    newCase: {
      title: "طلب جديد",
      subtitle: "قدّم شكوى أو قضية قانونية. سيتم إشعار الفريق القانوني فوراً.",
      card: "تفاصيل القضية",
      titleLabel: "العنوان",
      titlePh: "ملخص قصير، مثال: نزاع فوترة مع عميل شركات",
      type: "النوع",
      company: "فئة الشركة",
      priority: "الأولوية",
      desc: "الوصف",
      descPh: "صف المشكلة بالتفصيل: الأطراف المعنية والتواريخ والمبالغ وأي سياق ذي صلة…",
      attach: "المرفقات (اختياري)",
      dropTitle: "انقر لإرفاق ملفات PDF أو مستندات",
      dropHint: "PDF وWord وExcel وصور · بحد أقصى 15 ميجابايت للملف · حتى 10 ملفات",
      submit: "إرسال",
      submitting: "جارٍ الإرسال…",
      success: "تم تقديم {number} بنجاح",
      fail: "تعذر تقديم الطلب",
    },
    detail: {
      notFound: "القضية غير موجودة أو ليس لديك صلاحية الوصول.",
      back: "العودة إلى القضايا",
      changeStatus: "تغيير الحالة",
      edit: "تعديل",
      details: "التفاصيل",
      attachments: "المرفقات ({count})",
      upload: "رفع",
      noAttachments: "لا توجد مرفقات بعد.",
      assignedLawyer: "المحامي المعيَّن",
      assignToMe: "إسناد إليّ",
      timeline: "الجدول الزمني والمناقشة",
      noActivity: "لا يوجد نشاط بعد.",
      addComment: "أضف تعليقاً…",
      statusDialog: "تغيير حالة القضية",
      newStatus: "الحالة الجديدة",
      note: "ملاحظة (إلزامية — تُشارك مع الأطراف المعنية)",
      notePh: "سبب تغيير الحالة…",
      updateStatus: "تحديث الحالة",
      editCase: "تعديل القضية",
      metaType: "النوع",
      metaCompany: "الشركة",
      metaPriority: "الأولوية",
      metaBy: "قُدّمت بواسطة",
      metaCreated: "تاريخ الإنشاء",
      metaUpdated: "آخر تحديث",
      statusUpdated: "تم تحديث الحالة — تم إشعار الأطراف المعنية",
      statusFail: "تعذر تحديث الحالة",
      assignOk: "تم تحديث الإسناد",
      assignFail: "تعذر إسناد المحامي",
      updated: "تم تحديث القضية",
      updateFail: "تعذر تحديث القضية",
      commentFail: "تعذر نشر التعليق",
      uploadedToast: "تم رفع {name}",
      uploadFail: "فشل الرفع",
      downloadFail: "فشل التنزيل",
      needStatus: "اختر حالة وأضف ملاحظة قصيرة",
    },
    kpi: {
      title: "مؤشرات الأداء والتقارير",
      subtitle: "أداء العمليات القانونية خلال آخر 6 أشهر.",
      casesExcel: "Excel القضايا",
      kpiExcel: "تقرير مؤشرات Excel",
      total: "إجمالي القضايا",
      open: "المفتوحة",
      resolved: "تم حلها",
      escalated: "متصاعدة (مفتوحة)",
      avg: "متوسط مدة الحل",
      days: "{n} يوم",
      monthly: "حجم القضايا الشهري",
      byStatus: "حسب الحالة",
      byCompany: "حسب فئة الشركة",
      byPriority: "حسب الأولوية",
      workload: "عبء عمل المحامين",
      lawyer: "المحامي",
      assigned: "المعيَّنة",
      openCol: "المفتوحة",
      noAssignments: "لا توجد إسنادات بعد.",
      cases: "القضايا",
      loadFail: "تعذر تحميل مؤشرات الأداء",
    },
    logs: {
      title: "سجلات النشاط",
      subtitle: "سجل تدقيق كامل لكل إجراء في البوابة.",
      search: "ابحث بالمستخدم أو القضية أو التفاصيل…",
      allActions: "كل الإجراءات",
      empty: "لا توجد سجلات.",
      loadFail: "تعذر تحميل السجلات",
    },
    users: {
      title: "إدارة المستخدمين",
      subSuper: "إنشاء وإدارة جميع الحسابات بما فيها المشرفون.",
      subAdmin: "إنشاء وإدارة حسابات المحامين ومقدمي الطلبات.",
      add: "إضافة مستخدم",
      colName: "الاسم",
      colEmail: "البريد الإلكتروني",
      colRole: "الدور",
      colCompany: "الشركة",
      colStatus: "الحالة",
      colJoined: "تاريخ الانضمام",
      colActions: "إجراءات",
      active: "نشط",
      suspended: "موقوف",
      suspend: "إيقاف",
      reactivate: "إعادة تفعيل",
      you: "(أنت)",
      matrixTitle: "مصفوفة صلاحيات الأدوار",
      addTitle: "إضافة مستخدم جديد",
      fullName: "الاسم الكامل",
      namePh: "مثال: ليلى حداد",
      emailPh: "name@deltalab.com",
      tempPw: "كلمة مرور مؤقتة (8 أحرف على الأقل)",
      pwPh: "عيّن كلمة مرور أولية",
      role: "الدور",
      companyOptional: "وسم الشركة (اختياري)",
      create: "إنشاء الحساب",
      created: "تم إنشاء حساب {name}",
      roleChanged: "أصبح {name} الآن {role}",
      toggled: "{name} {state}",
      stateSuspended: "موقوف",
      stateReactivated: "مفعَّل",
      updateFail: "فشل التحديث",
      createFail: "تعذر إنشاء المستخدم",
      loadFail: "تعذر تحميل المستخدمين",
      capability: "القدرة",
      cap1: "تقديم الشكاوى والقضايا",
      cap2: "رفع المرفقات",
      cap3: "عرض جميع القضايا",
      cap4: "تغيير حالة القضية",
      cap5: "تعيين المحامين",
      cap6: "عرض مؤشرات الأداء والتقارير",
      cap7: "تصدير Excel",
      cap8: "عرض سجلات النشاط",
      cap9: "إدارة مقدمي الطلبات والمحامين",
      cap10: "إدارة المشرفين",
    },
  },
};
